import dayjs from 'dayjs'

function formatForApi(date: string | number | Date): string {
  return dayjs(date).format('YYYY-MM-DD')
}

export default formatForApi
